import {environment} from "../../env";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import type {Bag} from "../../services/classes/Bag";
import type {SelectProps} from "@mui/material/Select";
import Select from "@mui/material/Select";
import {AdminPanelSettings, Check, RemoveCircle, ShortText, VisibilityOff} from "@mui/icons-material";
import {useStores} from "../../stores";
import {Divider} from "@mui/material";
import {COLORS} from "~/style/colors-ts.ts";

type Props = SelectProps & {
    bags: Bag[]
    /** Show a check mark after the selected data bag in the open menu (Mithra 3.1 header) */
    showSelectedCheck?: boolean
};
export const SelectDatasetMenu: React.FC<Props> = ({bags, showSelectedCheck, ...selectProps}) => {
    const {authStore} = useStores();
    const showStaffMenu = environment.isTest || authStore.isMithraStaffGroup;
    const visible = bags.filter(b => !b.hidden);

    const label = (bag: Bag) => showStaffMenu ? <StaffMenuItem bag={bag}/> : bag.name;
    const item = (bag: Bag) => <MenuItem key={bag.id} value={bag.id} sx={showSelectedCheck ? {gap: 1.5} : undefined}>
        {label(bag)}
        {showSelectedCheck && bag.id === selectProps.value &&
            <Check fontSize="small" sx={{ml: 'auto', color: COLORS.primary[500]}}/>}
    </MenuItem>;
    // Keep the check mark out of the closed select
    const renderValue = showSelectedCheck ? (value: unknown) => {
        const bag = bags.find(b => b.id === value);
        return bag ? label(bag) : '';
    } : undefined;

    if (!showStaffMenu) {
        return <Select renderValue={renderValue} {...selectProps}>
            {visible.map(item)}
        </Select>
    } else {
        // Show all other databags as well
        const hidden = bags.filter(b => b.hidden && !b.disabled);
        const disabled = bags.filter(b => b.hidden && b.disabled);

        // Note: We cannot use fragments here
        return <Select renderValue={renderValue} {...selectProps}>
            {visible.map(item)}
            {hidden.length > 0 && <Divider/>}
            {hidden.map(item)}
            {disabled.length > 0 && <Divider/>}
            {disabled.map(item)}
        </Select>
    }
}

const StaffMenuItem: React.FC<{bag: Bag}> = ({bag}) => {
    const icons = [
        bag.hidden ? <VisibilityOff key="hidden" titleAccess="Hidden"/> : null,
        bag.disabled ? <RemoveCircle key="disabled" titleAccess="Disabled"/> : null,
        bag.is_sample_of ? <ShortText key="is_sample_of" titleAccess="Sample"/> : null,
    ].filter(Boolean);
    return <>
        <AdminPanelSettings/>
        {icons}
        [{bag.id}] {bag.name}
    </>;
}
